import React from 'react';

const configs = { tenant: {}, organization: {}, businessCountry: null };
export default React.createContext(configs);
